import useSWRMutation, {
  MutationFetcher,
  SWRMutationConfiguration,
  SWRMutationResponse,
} from 'swr/mutation';
import { Arg } from './abstractFetcher';
import { EcoisKeys } from './type';

function useEcoisSWRMutation<Data = any, ExtraArg extends Arg = never, Error = any>(
  key: EcoisKeys,
  fetcher: MutationFetcher<Data, EcoisKeys, ExtraArg>,
  options?: SWRMutationConfiguration<Data, Error, EcoisKeys, ExtraArg>,
): SWRMutationResponse<Data, Error, EcoisKeys, ExtraArg> {
  return useSWRMutation(key, fetcher, options);
}

export { useEcoisSWRMutation };
